(ns frontend.view.data-import.steps.advertise
  (:require [common.localization :as loc]
            [reagent.core :as r]
            [frontend.view.data-import.db :as db]
            [frontend.view.data-import.events :as events]
            [frontend.bootstrap.components :as rbs]
            [ui.components.button.view :as button]))

(defn view []
  [:div
   [:div
    {:class-name "grid grid-cols-12 gap-4"}
    [:div
     {:class "col-span-5"}
     [:h3
      {:class-name "zap-modal-subtitle"}
      (loc/tr :import-step-self-service-header)]
     [:p {:class-name "zap-modal-text"}
      (loc/tr :import-step-self-service-text)]]
    [:div
     {:class-name "col-span-2 vertical-divider-with-text"}
     [:p
      (loc/tr :or)]]
    [:div
     {:class "col-span-5"}
     [:h3
      {:class-name "zap-modal-subtitle"}
      (loc/tr :import-step-concierge-header)]
     [:p {:class-name "zap-modal-text"}
      (loc/tr :import-step-concierge-text)
      [:a {:href       (str "mailto:" (loc/tr :import-step-concierge-email))
           :class-name "concierge-mail-to"}
       (loc/tr :import-step-concierge-email)]]]]
   [:div
    {:class "mt-3 mb-1 flex justify-center"}
    [button/primary-solid
     {:on-click   #(events/set-step! :import-step-intro)}
     (loc/tr :import-step-begin-import-button)]]])
